// src/utils/logger.js
// Log controller
// REACT_APP_SHOW_LOGS=true (development, testing, local)
// REACT_APP_SHOW_LOGS=false or not defined (implantation, production)
const shouldShowLogs = process.env.REACT_APP_SHOW_LOGS === 'true';

export const logger = {
  debug: (...args) => {
    if (shouldShowLogs) {
      console.log(...args);
    }
  },

  info: (...args) => {
    if (shouldShowLogs) {
      console.info(...args);
    }
  },

  warn: (...args) => {
    if (shouldShowLogs) {
      console.warn(...args);
    }
  },

  error: (...args) => {
    // Always show errors
    console.error(...args);
  },

  // For cases where you need to see truncated tokens in development
  debugToken: (label, token) => {
    if (shouldShowLogs) {
      if (token && typeof token === 'string') {
        console.log(`${label} (first 20 chars):`, token.substring(0, 20) + '...');
      } else {
        console.log(`${label}:`, !!token);
      }
    }
  }
};
